<template>
  <svg id="close" viewBox="0 0 24 24" width="24" height="24">
    <path d="M.546 2.667L2.667.546 23.88 21.759l-2.12 2.121z"></path>
    <path d="M21.76.546l2.12 2.121L2.667 23.88.546 21.76z"></path>
  </svg>
</template>
